"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tresana": {
    "ricco": [{
      "hkey": "507ec0ae",
      "slug": "tresana",
      "name": "Tresana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1683c08e": [{
      "hkey": "7c10ba9f",
      "slug": "bola-groppo",
      "name": "Bola-Groppo",
      "primary": true,
      "skipSearch": false
    }],
    "bola": [{
      "hkey": "7c10ba9f",
      "slug": "bola-groppo",
      "name": "Bola-Groppo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "99d912d5": [{
      "hkey": "3c061ab5",
      "slug": "careggia-serrapiana",
      "name": "Careggia-Serrapiana",
      "primary": true,
      "skipSearch": false
    }],
    "careggia": [{
      "hkey": "3c061ab5",
      "slug": "careggia-serrapiana",
      "name": "Careggia-Serrapiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "37ad845d": [{
      "hkey": "23a2852b",
      "slug": "corneda-bottria",
      "name": "Corneda-Bottria",
      "primary": true,
      "skipSearch": false
    }],
    "corneda": [{
      "hkey": "23a2852b",
      "slug": "corneda-bottria",
      "name": "Corneda-Bottria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ef0eb5f0": [{
      "hkey": "64814c47",
      "slug": "giovagallo",
      "name": "Giovagallo",
      "primary": true,
      "skipSearch": false
    }],
    "giovangallo": [{
      "hkey": "64814c47",
      "slug": "giovagallo",
      "name": "Giovagallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8ea81fd4": [{
      "hkey": "507ec0ae",
      "slug": "tresana",
      "name": "Tresana",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;